const SDK_VERSION = '7.119.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
